// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Link } from '@zapier/common-components';

import SimplePromo, {
  type SimplePromoProps,
} from 'app/login/components/SimplePromo';
import {
  PlatformContainerStartFeaturedItems,
  PlatformContainerWhyFeaturedItems,
} from 'app/login/components/FeatureItems';
import 'app/login/components/PlatformPromo.scss';

const bem = bemify('platform-signup');

export type Props = SimplePromoProps & {
  createPotentialPartner: (data: {
    email: string,
    has_api?: boolean,
    company_web_site?: string,
  }) => void,
  resetPotentialPartner: () => void,
  isSaving: boolean,
  errors: Array<string>,
  hasSubmitted: boolean,
};

const PlatformPromoSignUp = (props: Props) => {
  return (
    <React.Fragment>
      <SimplePromo
        {...props}
        className={bem('__simple-promo')}
        condensedIcon="info"
        title="Sign up for Zapier’s free platform to start building your integration"
      >
        <PlatformContainerStartFeaturedItems />
      </SimplePromo>
      <SimplePromo
        {...props}
        className={bem('__simple-promo')}
        condensedIcon="info"
        title="Why Build an Integration?"
      >
        <PlatformContainerWhyFeaturedItems />
      </SimplePromo>
      <div className={bem('__subscribe-container')}>
        <p>
          Not ready to build, but want to know more? Fill out{' '}
          <Link href="https://zapier.typeform.com/to/NrX53M" target="_blank">
            this form
          </Link>{' '}
          and we'll follow up with more info.
        </p>
      </div>
    </React.Fragment>
  );
};

export default PlatformPromoSignUp;
